import React from "react";
import '../../App.css';
import './Career.css';
import Footer from "../Footer";

export default function Career() {
    return (
        <>
            {/* Hero Section */}
            <div className='career-hero'>
                <div className='career-hero-content'>
                    <div className='career-title-row'>
                        <h1>CAREER</h1>
                        <div className='career-coffee-cup'>
                            <div className='career-cup-steam'>
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                            <div className='career-cup-rim'></div>
                            <div className='career-cup-body'>
                                <div className='career-cup-handle'></div>
                            </div>
                            <div className='career-cup-saucer'></div>
                        </div>
                    </div>
                    <p>JOIN THE TEAM BEHIND THE ROAST</p>
                </div>
            </div>

            {/* Intro Section */}
            <section className='career-intro'>
                <div className='career-section-container'>
                    <h2 className='career-heading'>WE'RE GROWING — AND WE WANT THE RIGHT PEOPLE ON THE JOURNEY.</h2>
                    <p className='career-text'>
                        At OFFF THE ROAST, we're building something more than a coffee brand. We're creating experiences that bring people together through craft, culture, and community. If you're passionate, driven, and ready to be part of something meaningful — we'd love to hear from you.
                    </p>
                </div>
            </section>

            {/* Business Development Role */}
            <section className='career-roles'>
                <div className='career-section-container'>
                    <h2 className='career-section-title'>OPEN POSITIONS</h2>
                    <div className='career-role-card'>
                        <h3>Business Development</h3>
                        <span className='career-role-tag'>San Jose, CA · Part-Time</span>
                        <p className='career-role-description'>
                            We're looking for a hungry, relationship-driven Business Development lead to help us expand our reach and build meaningful partnerships across the Bay Area and beyond.
                        </p>
                        <h4>What You'll Do</h4>
                        <ul className='career-role-list'>
                            <li>Identify and pursue new business opportunities, partnerships, and collaborations</li>
                            <li>Build and maintain relationships with corporate clients, event planners, and local businesses</li>
                            <li>Develop strategies to grow our team-building, pop-up, and private class bookings</li>
                            <li>Collaborate with the founding team on brand growth and go-to-market initiatives</li>
                        </ul>
                        <h4>What We're Looking For</h4>
                        <ul className='career-role-list'>
                            <li>Strong communication and interpersonal skills</li>
                            <li>Self-starter mentality with the ability to work independently</li>
                            <li>Passion for coffee, community, and building from the ground up</li>
                            <li>Bay Area based (San Jose / Santa Clara preferred)</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className='career-cta'>
                <div className='career-section-container'>
                    <h2 className='career-cta-heading'>Interested?</h2>
                    <p className='career-cta-text'>
                        Send your resume and a brief intro to <a href='mailto:info@offftheroast.com' className='career-email-link'>info@offftheroast.com</a>
                    </p>
                    <p className='career-cta-subtext'>We review every application and will get back to you as soon as possible.</p>
                </div>
            </section>

            <Footer />
        </>
    );
}
